import { render, staticRenderFns } from "./AdditionalDocuments.vue?vue&type=template&id=67e2d579&scoped=true&"
import script from "./AdditionalDocuments.vue?vue&type=script&lang=js&"
export * from "./AdditionalDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalDocuments.vue?vue&type=style&index=0&id=67e2d579&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e2d579",
  null
  
)

export default component.exports